import Papa from 'papaparse';

export const CSV_DELIMITER = ',';
export const TSV_DELIMITER = '\t';

export const CSV_MIME_TYPE = 'text/csv';

export const PARSE_ALL_ROWS = 0;

export function parseCsvFile(file, delimiter = CSV_DELIMITER, numberOfRowsToParse = PARSE_ALL_ROWS) {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      delimiter,
      header: true,
      skipEmptyLines: true,
      preview: numberOfRowsToParse,
      complete: (results) => {
        const { data, errors } = results;
        if (errors?.length > 0) {
          reject(errors);
        } else {
          resolve(data);
        }
      },
    });
  });
}

export async function getCsvHeaders(file, delimiter = CSV_DELIMITER) {
  const csvObjects = await parseCsvFile(file, delimiter, 1);
  if (!csvObjects.length) {
    throw new Error('Could not parse csv file');
  }
  return Object.keys(csvObjects[0]);
}
